import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = '/subscriptions';

class SubscriptionService {
  subscribeAndAddPaymentMethod = async stripePaymentMethodId => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/subscribe`, { stripePaymentMethodId });
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, message } = response.data;

      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while adding subscribing and adding new payment method.');
    }
  };

  addPaymentMethod = async stripePaymentMethodId => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/payment-method`, { stripePaymentMethodId });
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, message } = response.data;

      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while adding new payment method.');
    }
  };

  cancelSubscription = async () => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/cancel`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, message } = response.data;

      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while canceling subscription.');
    }
  };

  subscribeWithCoupon = async body => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/subscribe/coupon`, body);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, message } = response.data;

      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while subscribing with promo code.');
    }
  };
}
const subscriptionService = new SubscriptionService();

export default subscriptionService;
